import { getBearerToken, getAuthorizationHeaderValue } from "../authToken";

/**
 * eventsource@3 only supports custom headers via a custom `fetch` implementation.
 * The legacy `{ headers: { Authorization } }` init option is silently ignored.
 */
export const createAuthenticatedEventSourceFetch = (getToken = getBearerToken) => {
  return (url, init = {}) => {
    const token = typeof getToken === "function" ? getToken() : getToken;
    const headers = new Headers(init.headers || {});

    if (!headers.has("Accept")) {
      headers.set("Accept", "text/event-stream");
    }

    const authorization =
      token && !String(token).toLowerCase().startsWith("bearer ")
        ? `Bearer ${token}`
        : token || getAuthorizationHeaderValue();

    if (authorization) {
      headers.set("Authorization", authorization);
    }

    return fetch(url, { ...init, headers });
  };
};
